/**
 * Utilidades para el módulo de Clientes
 */

/**
 * Limpia un objeto eliminando propiedades con valores falsy
 * @param {Object} data - Objeto a limpiar
 * @returns {Object} - Objeto limpio
 */
export const cleanFormData = (data) => {
  return Object.fromEntries(
    Object.entries(data).filter(([_, v]) => v)
  );
};

/**
 * Filtra campos específicos de un objeto
 * @param {Object} data - Objeto fuente
 * @param {Array<string>} fields - Campos a extraer
 * @returns {Object} - Objeto filtrado
 */
export const filterFields = (data, fields) => {
  const clean = {};
  fields.forEach((key) => {
    if (data[key]) clean[key] = data[key];
  });
  return clean;
};

